// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/arcal-pilot-controlled-lighting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/arcal-pilot-controlled-lighting/arcal-pilot-controlled-lighting.js';

mount([g0]);
